function Actions(actions) {

    this.name='actions';
    this.actionsJson=actions;
}

export {Actions};
